export default {
  Product: 1,
  Service: 2,
  Device: 3,
  Expense: 4,
};
